import { render, staticRenderFns } from "./PaginateComponent.vue?vue&type=template&id=bdc680bc&"
import script from "./PaginateComponent.vue?vue&type=script&lang=js&"
export * from "./PaginateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports